export default "__VITE_ASSET__5ddef1fa__"